import Swal from "sweetalert2";

export const SuccessAlert = (data) => {
  return Swal.fire({
    toast: true,
    position: "top",
    timerProgressBar: true,
    timer: 3000,
    showConfirmButton: false,
    icon: "success",
    iconColor: "#3C0096",
    title: data,
  });
};

export const ErrorAlert = (data) => {
  return Swal.fire({
    toast: true,
    position: "top",
    timerProgressBar: true,
    timer: 3000,
    showConfirmButton: false,
    icon: "error",
    iconColor: "#F8333C",
    title: data,
  });
};

export const WarningAlert = (data) => {
  return Swal.fire({
    toast: true,
    position: "top",
    timerProgressBar: true,
    timer: 3000,
    showConfirmButton: false,
    icon: "warning",
    iconColor: "#F9C8DE",
    title: data,
  });
};
